import { pass, fail, skip } from "../buildResult";
import { defineTest } from "../defineTest";

const parseIcd10CodesV2 = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value !== "string") return value;

  const trimmed = value.trim();
  if (!trimmed || trimmed.toLowerCase() === "null") return null;

  try {
    return JSON.parse(trimmed);
  } catch {
    return trimmed;
  }
};

const isIcd10CodesV2Empty = (value) => {
  const data = parseIcd10CodesV2(value);

  if (data === null || data === undefined) return true;
  if (typeof data === "string") return data.trim() === "";
  if (Array.isArray(data)) return data.length === 0;
  if (typeof data !== "object") return false;

  if (Object.keys(data).length === 0) return true;

  const codes = data?.selected_codes?.codes;
  if (Array.isArray(codes)) return codes.length === 0;

  return false;
};

const formatPassMessage = (value) => {
  const data = parseIcd10CodesV2(value);
  const codes = data?.selected_codes?.codes;
  if (Array.isArray(codes) && codes.length > 0) {
    return `ICD-10 v2 coding data present (${codes.length} code${codes.length === 1 ? "" : "s"})`;
  }
  return "ICD-10 v2 coding data present";
};

export default defineTest(
  "icd10_codes_v2_present",
  "ICD-10",
  ({ patient }) => {
    if (!patient?.patient_id) return skip("No patient record");

    if (isIcd10CodesV2Empty(patient.icd10_codes_v2)) {
      return fail(
        "ICD-10 is missing",
        "patient.icd10_codes_v2 is null, empty, or has no selected codes in postgres"
      );
    }

    return pass(formatPassMessage(patient.icd10_codes_v2));
  }
);
